module.exports = __webpack_public_path__ + "static/media/traveller.14117e27.png";